import React from 'react';
import Modal from '../Modal/Modal';
import { Typography, Link, Box } from '@material-ui/core';
import {connect} from 'react-redux';
import Button from "../Button";
import { setModalReset } from "../../actions/app";

const CustomizeGiftAddToCartErrorModal = ({setModalReset, extraErrorMessage}) => (
    <Modal
        id="customize-gift-add-to-cart-error-modal"
        maxWidth="sm"
        title="We are sorry"
    >
        <Typography>There was an issue adding your items to your cart. Please try again or contact customer support at <Link href={'mailto:support@giftya.com'}>support@giftya.com</Link>.</Typography>
        {extraErrorMessage && (
            <Typography>{extraErrorMessage}</Typography>
        )}

        <Box mt={6} mb={2} maxWidth={300}>
            <Button onClick={() => {setModalReset()}} variant="contained" fullWidth={true} color="secondary">OK</Button>
        </Box>
    </Modal>
);


export default connect(
    () => ({}),
    {
        setModalReset
    }
)(CustomizeGiftAddToCartErrorModal);